import { translateColumns } from "../../../../../utils/tableUtils";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { useTranslation } from "react-i18next";
import {
  DownloadOutlined,
  EyeOutlined,
  FileDoneOutlined,
  HistoryOutlined,
  LeftOutlined,
  MoreOutlined,
  RightOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  MenuProps,
  Pagination,
  PaginationProps,
  Space,
  Table,
  TableColumnsType,
} from "antd";
import moment from "moment";
import React, { FunctionComponent, useEffect, useState } from "react";
import { CourseApprovalType } from "../../../../../types/course-plan-approval";
import { useNavigate } from "react-router-dom";
import CourseConstructionPlan from "../../../mooc-course-construction-plan1/CourseConstructionPlan";
import { routesConfig } from "../../../../../config/routes";

type tableDataProps = {
  locale: object;
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  setPageNumber?: (pageNumber: number) => void;
  setPageSize?: (pageNumber: number) => void;
  listCourseApproval: CourseApprovalType[];
  historyNavigation: Boolean;
  setHistoryNavigation?: (historyNavigation: Boolean) => void;
  loading: boolean;
  activeTabKey: string;
};
const TableApprovalPlan: FunctionComponent<tableDataProps> = ({
  locale,
  totalRecords,
  pageNumber,
  pageSize,
  setPageNumber,
  setPageSize,
  listCourseApproval,
  historyNavigation,
  setHistoryNavigation,
  loading,
  activeTabKey,
}) => {
  const { t } = useTranslation();
  const [totalPage, setTotalPage] = useState(totalRecords);
  const [isOpenModalDownload, setIsOpenModalDownload] =
    useState<boolean>(false);
  const [courseConstructPlanId, setCourseConstructPlanId] = useState<number>();
  const navigation = useNavigate();
  const getOptionsAction = (record: any): MenuProps["items"] => {
    let options: MenuProps["items"] = [
      // {
      //     key: "1",
      //     label: t("Phê duyệt kế hoạch", "Phê duyệt kế hoạch"),
      //     icon: <FileDoneOutlined />
      // },
      // {
      //     key: "2",
      //     label: t("Phê duyệt nhanh kế hoạch", "Phê duyệt nhanh kế hoạch"),
      //     icon: <ThunderboltOutlined />
      // },
      {
        key: "3",
        label: t("Lịch sử phê duyệt", "Lịch sử phê duyệt"),
        icon: <HistoryOutlined />,
      },
      {
        key: "4",
        label: t("Tải nội dung kế hoạch", "Tải nội dung kế hoạch"),
        icon: <DownloadOutlined />,
      },
    ];
    if (!record.isLeader) {
      options = options.filter(
        (options) => options?.key !== "1" && options?.key !== "2"
      );
    }
    return options;
  };

  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      key: "numericalOrder",
      width: 2,
      render: (_: any, record: any, index: number) => {
        const orderNumber = (pageNumber - 1) * pageSize + index + 1;
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Mã kế hoạch", "Mã kế hoạch"),
      width: 4,
      dataIndex: "registrationCode",
    },
    {
      title: t("Tên kế hoạch", "Tên kế hoạch"),
      sorter: (a, b) => a.registrationName.localeCompare(b.registrationName),
      width: 12,
      dataIndex: "registrationName",
      render: (_: any, record) => {
        return (
          <div className="table-order-course-name">
            <img
              className="item-carousel__image"
              loading="eager"
              alt=""
              src={"/images/ic_school_placeholder.svg"}
            />
            <div>
              <span className="course-title">{record.registrationName}</span>
              <span>{record.universityName}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Ngày gửi phê duyệt", "Ngày gửi phê duyệt"),
      width: 5,
      dataIndex: "submissionDate",
      render: (_: any, record) => {
        return (
          <>
            {record.submissionDate ? formatDateV2(record.submissionDate) : null}
          </>
        );
      },
    },
    {
      title: t("Ngày phê duyệt", "Ngày phê duyệt"),
      width: 5,
      dataIndex: "approvalDate",
      render: (_: any, record) => {
        return (
          <>{record.approvalDate ? formatDateV2(record.approvalDate) : null}</>
        );
      },
    },
    {
      title: "",
      width: 3,
      fixed: "right",
      render: (_: any, record) => {
        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() => {
                  navigation(
                    `/course-plan/approval/approval-detail/${record.courseConstructionPlanId}`,
                    {
                      state: {
                        historyCheck: false,
                        typeApproval: "2",
                        view: true,
                        keyTab: activeTabKey,
                        modeback: "backState",
                        backLink: `/${routesConfig.coursePlan}/${routesConfig.approval}`,
                      },
                    }
                  );
                }}
              >
                <EyeOutlined />
              </a>
              <Dropdown
                menu={{
                  items: getOptionsAction(record),
                  onClick: ({ key }) => {
                    if (key === "3") {
                      navigation(
                        `/course-plan/approval/approval-detail/${record.courseConstructionPlanId}`,
                        { state: { historyCheck: true, view: true } }
                      );
                    }
                    if (key === "4") {
                      setIsOpenModalDownload(true);
                      setCourseConstructPlanId(record.courseConstructionPlanId);
                    }
                  },
                }}
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
    },
  ];
  const formatDateV2 = (date: string) => {
    return moment(date).format("DD/MM/yyyy");
  };

  const itemRender: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return <LeftOutlined />;
    }
    if (type === "next") {
      return <RightOutlined />;
    }
    return originalElement;
  };
  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    if (setPageNumber && setPageSize) {
      setPageNumber(page);
      setPageSize(pageSize);
      setTotalPage(totalRecords);
    }
  };

  return (
    <div className="table-wrapper">
      <Table
        size="middle"
        tableLayout="fixed"
        pagination={false}
        columns={translateColumns(dataColumns, t)}
        rowKey={"id"}
        scroll={{ x: 1000, y: 600 }}
        locale={locale}
        dataSource={listCourseApproval}
        loading={loading}
      />
      <Pagination
        total={totalRecords}
        showSizeChanger
        pageSize={pageSize}
        current={pageNumber}
        className="pagination-table"
        onChange={onChange}
        itemRender={itemRender}
        locale={{
          items_per_page: t("/ trang", "/ trang"),
          jump_to: t("Đi đến trang", "Đi đến trang"),
          page: "",
        }}
        showQuickJumper
        showTotal={(total) => `${t("Tổng số", "Tổng số")} ${total} ${t("bản ghi", "bản ghi")}`}
      />
      {isOpenModalDownload && (
        <CourseConstructionPlan
          isOpen={isOpenModalDownload}
          setIsOpen={setIsOpenModalDownload}
          courseConstructPlanId={courseConstructPlanId}
        />
      )}
    </div>
  );
};

export default TableApprovalPlan;
